import React, {useContext} from 'react';
import isEmpty from "lodash/isEmpty";
import {PromotionEstimation, PromotionEstimationList, PromotionEstimationText} from "./Reservation.style";
import {ReactSVG} from "react-svg";
import promotionEstimationIcon from "../../../assets/images/promotion_estimation_icon.svg";
import {formatPrice} from "../../../library/helpers/utils";
import {useTranslation} from "react-i18next";
import {PopeyeContext} from "../../../context/PopeyeProvider";

const PromotionEstimations = props => {
    const {pricing, marina_settings, centerAndFill} = props;
    const { t } = useTranslation();
    const {isPreSignatureStatus,isPopeyeMember} = useContext(PopeyeContext);

    if ((!isPopeyeMember && !isPreSignatureStatus) || isEmpty(pricing) || isEmpty(pricing.popeye))
        return null;

    const { total_money_saved, popeye } = pricing;
    const { number_of_expected_points } = popeye;

    return (
        <PromotionEstimationList centerAndFill={centerAndFill}>
            {Boolean(total_money_saved) && (
                <PromotionEstimation centerAndFill={centerAndFill}>
                    <ReactSVG
                        className='estimation-icon'
                        src={promotionEstimationIcon}
                    />
                    <PromotionEstimationText>
                        {t('RESERVAION_WIDGET_POPEYE_SAVED', {
                            amount_with_currency: formatPrice(
                                total_money_saved,
                                'en',
                                marina_settings.currency
                            )
                        })}
                    </PromotionEstimationText>
                </PromotionEstimation>
            )}
            {Boolean(number_of_expected_points) && (
                <PromotionEstimation centerAndFill={centerAndFill}>
                    <ReactSVG
                        className='estimation-icon'
                        src={promotionEstimationIcon}
                    />
                    <PromotionEstimationText>
                        {t('RESERVATION_WIDGET_POPEYE_EARN', {
                            number_pf_points: number_of_expected_points
                        })}
                    </PromotionEstimationText>
                </PromotionEstimation>
            )}
        </PromotionEstimationList>
    );
}

export default PromotionEstimations;
